// @flow
import {connect} from 'react-redux';
import Configure from '../components/Configure';

import type {RootState} from '../../../modules';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    dueInformation: state.tiersList.dueInformation,
  }),
  null
)(Configure);
